import { Link } from "react-router-dom";

/**
 * Live status badge announcing the Pittsburgh pilot. Small gold dot pulses to
 * indicate the pilot is actively enrolling. Links to the Partners page.
 */
export default function PilotBadge({ variant = "light", className = "", to = "/partners" }) {
  const isDark = variant === "dark";
  return (
    <Link
      to={to}
      data-testid="pilot-badge"
      className={`inline-flex items-center gap-2 pl-2 pr-4 py-1.5 rounded-full text-xs font-semibold tracking-tight transition-colors ${
        isDark
          ? "bg-white/10 border border-gold/40 text-cream hover:bg-white/15"
          : "bg-white border border-gold/50 text-navy hover:border-gold"
      } ${className}`}
    >
      <span className="relative flex w-2.5 h-2.5" aria-hidden>
        <span className="absolute inline-flex w-full h-full rounded-full bg-gold opacity-75 animate-ping" />
        <span className="relative inline-flex w-2.5 h-2.5 rounded-full bg-gold" />
      </span>
      <span>
        Pittsburgh Pilot · <span className={isDark ? "text-gold-light" : "text-gold-deep"}>Now enrolling partners</span>
      </span>
    </Link>
  );
}
